import { Utils } from 'underscore-extensions';
import services from 'services/module';
import {Strings} from 'Strings';
import {AuthenticationSvc} from './AuthenticationSvc';
import {LocalStorageSvc} from './LocalStorageSvc';

export class OAuthCallbackSvc {
    constructor(private $location: ng.ILocationService,
                private $log: ng.ILogService,
                private $state: ng.ui.IStateService,
                private $stateParams: any,
                private AuthenticationSvc: AuthenticationSvc,
                private LocalStorageSvc: LocalStorageSvc) {
    }

    doLogin(params: any, stateParams: any) {
        this.$log.debug('Callback activated', {params});
        const getToken = () => {
            const token = params.access_token || stateParams.code;
            return _.isArray(token) ? token[0] : token;
        };
        const oauthService = stateParams.provider.toUpperCase();
        const product = stateParams.product || Utils.getProduct().toLowerCase();
        const thirdPartyRedirect = this.LocalStorageSvc.get<string>('_animatron_redirect_onlogin');
        switch (oauthService) {
            case 'GOOGLE':
            case 'FACEBOOK':
            case 'TWITTER':
            case 'DRIBBBLE':
            case 'WISTIA':
            case 'HUBSPOT':
            case 'VIMEO':
            case 'DROPBOX':
            case 'GDRIVE':
                if (!Strings.isBlank(getToken())) {
                    this.AuthenticationSvc.loginOAuth(getToken(), oauthService, product)
                        .then((secureUser: anm.SecureUser) => {
                            if (thirdPartyRedirect && !thirdPartyRedirect.includes(location.host)) {
                                document.querySelector('html').style['background-color'] = 'white';

                                document.querySelector('html').innerHTML = '<div style="font-size:25px">redirecting back...</div>';
                            } else {
                                const homeUrl = product === 'wave' ? 'my-projects' : 'home';
                                this.$location.hash('');
                                this.$state.go(
                                    secureUser.isNew ? `${product}-activate-oauth` : homeUrl,
                                    {},
                                    { reload: true }
                                  );
                            }
                    });
                } else {
                    this.$location.path('/404');
                }
                break;
            case 'TWITTER_EMOTIONS':
                this.LocalStorageSvc.set('_animatron_twitter',
                    {token: getToken(), secret: params.secret_token});
                window.close();
                break;
            case 'FACEBOOK_EMOTIONS':
                this.LocalStorageSvc.set('_animatron_facebook', {token: getToken()});
                window.close();
                break;
            default:
                if (oauthService.endsWith('_SHARE')) {
                    window['share_updated'](getToken());
                    if (window.opener) {
                        window.opener['share_updated'](getToken());
                    }
                } else {
                    throw new Error('Unknown provider ' + oauthService);
                }
        }
    }

    onCallback($stateParams: any, hash: string) {
        const params = hash.split('&').map(s => s.split('=')).reduce((acc, arr) => {
            acc[arr[0]] = arr[1];
            return acc;
        }, {});
        if (window.opener) {
            try {
                (window.opener.angular.element(window.opener.document.body)
                    .injector()
                    .get('OAuthCallbackSvc') as OAuthCallbackSvc)
                    .doLogin(params, $stateParams);
            } catch (e) {
                this.LocalStorageSvc.set('auth', {params, stateParams: $stateParams});
            } finally {
                window.close();
            }
        } else {
            this.doLogin(params, $stateParams);
        }
    }
}

services.service('OAuthCallbackSvc', OAuthCallbackSvc);



// WEBPACK FOOTER //
// ./app/assets/javascripts/services/OAuthCallbackSvc.ts